var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.5 0C6.74688 0 6.13636 0.610521 6.13636 1.36364V6.13636H1.36364C0.610521 6.13636 0 6.74688 0 7.5C0 8.25311 0.61052 8.86364 1.36364 8.86364H6.13636V13.6364C6.13636 14.3895 6.74688 15 7.5 15C8.25312 15 8.86364 14.3895 8.86364 13.6364V8.86364H13.6364C14.3895 8.86364 15 8.25312 15 7.5C15 6.74688 14.3895 6.13636 13.6364 6.13636H8.86364V1.36364C8.86364 0.610521 8.25312 0 7.5 0Z","fill":"#011949"}));
}

PlusInline.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
